



















































































import Vue from "vue";
import PDF from "@/views/dashboard/PDF.vue";
import { bus } from "@/utils/event-emitter";

export default Vue.extend({
  data() {
    return {
      open: false
    };
  },
  components: {
    PDF
  },
  methods: {
    switchMenuType() {
      this.open = false;
      bus.$emit("switchMenuType");
    }
  }
});
